import { Icon } from 'common/icon';
import Link from 'next/link';
import { navigationBlocksInfo } from '../template';
import styles from './styles.module.css';

interface TrustedCasinosProps {
  description: string;
  text: string;
  icon: React.JSX.Element;
  color: string;
  href?: string;
}

export const NavigationBlock = ({
  description,
  text,
  icon,
  color,
  href = '#',
}: TrustedCasinosProps) => {
  return (
    <Link href={href} className={styles.container}>
      <div className={styles.content}>
        <div className={styles.mainColumn}>
          <div className={styles.infoSection}>
            <div className={styles.infoContent}>
              <div className={styles.trustedCasinosColumn}>
                <div
                  className={styles.trustedCasinosBox}
                  style={{ backgroundColor: color }}
                >
                  <div className={styles.trustedCasinosContent}>
                    {icon}
                    <div className={styles.trustedCasinosText}>{text}</div>
                  </div>
                </div>
              </div>
              <div className={styles.descriptionColumn}>
                <p className={styles.description}>{description}</p>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.ctaColumn}>
          <div className={styles.ctaButton}>
            <span className={styles.ctaText}>{'FIND THE BEST CASINO'}</span>
            <div
              className={styles.arrow_icon}
              style={{ backgroundColor: color }}
            >
              <Icon.Arrow width={26} height={26} fill="#121212" />
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

const getRandomItem = (array: any) =>
  array[Math.floor(Math.random() * array.length)];

export const RandomNavigationBlock = ({ data }: any) => {
  const randomBlock = getRandomItem(data ?? navigationBlocksInfo);

  return <NavigationBlock {...randomBlock} />;
};
